import {useTranslation} from "react-i18next";
import React, {useCallback} from "react";
import lodash from "lodash";
import confirmationDialog from "../../confirmationDialog";
import Button from "@material-ui/core/Button";
import WriteCommentBox from "./WriteCommentBox";

function WriteComment(props) {
    const {t, i18n} = useTranslation();

    let diff = [props.globalComment, props.request, props.signerID];
    let getSigner = useCallback(function () {
        let f = lodash.find(props.request.signers, {
            unique_id: props.signerID,
        });

        return f ? f : {};
    }, diff);

    let callBox = useCallback(() => {
        let dialog = {
            title: t("dialog_write_comment_title"),
            ok: false
        };
        let data = props.request;
        let signer = getSigner();
        if (signer && (signer.declined || signer.signed)) {
            dialog.title = t("your_comment_title");
            dialog.cancelText = false;
            dialog.okText = t("ok");
            dialog.ok = () => {
                dialog.close();
            };
            dialog.content = <div style={{minWidth: 300}}>
                <div>
                    <div>
                        {signer.message}
                    </div>
                </div>
            </div>;
        } else {
            dialog.content = <WriteCommentBox dialog={dialog}
                                              help={data && data.sign_request.comment_help_text ? data.sign_request.comment_help_text : null} {...props}/>;
        }
        confirmationDialog(dialog)
    }, diff);

    let isAddCommentVisible = useCallback(() => {
        let signer = getSigner();
        let d = props.request;
        return ((signer.declined || signer.signed) && signer.message) || ((!signer.signed && !signer.declined) && d && d.sign_request && !d.sign_request.hide_write_comment_button);
    }, diff);


    let sig = getSigner();
    return <div style={{minWidth: 300}} className={"write-comment-action-wrapper"}>
        {isAddCommentVisible() ? <Button variant="contained"
                                         color="secondary"
                                         className={"write-comment-action"}
                                         onClick={callBox}>{t(((sig.signed || sig.declined) && sig.message && sig.message.length) ? "view_comment" : "write_comment")}</Button> : null}
    </div>
}

export default WriteComment;